import { RootState } from "@/store/types";
import axios from "axios";
import { ActionTree } from "vuex";
import { StatisticState, DetailFilterParams, GroupFilterParams } from "./types";

export const actions: ActionTree<StatisticState, RootState> = {
  async getWhatsappStatisticDetail({commit}, data: DetailFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/detail/whatsapp',
        params: data
      });
      let messages = resp.data?.messages ?? []
      if (data.page_number > 1) {
        commit('pushWhatsappStatisticDetail', messages);
      } else {
        commit('setWhatsappStatisticDetail', messages);
      }
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async exportWhatsappStatisticDetail({commit}, filter: DetailFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/detail/whatsapp/export',
        params: filter
      });
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async getWhatsappStatisticDetailInfo({commit, dispatch}, id: string) {
    try {
      const resp = await axios({
        url: "/stats-api/detail/whatsapp/" + id.replace(/#/g, "%23"),
      })
      return resp;
    } catch (error) {
      throw error;
    }
  },
  async getWhatsappStatisticGroup({commit}, filter: GroupFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/group/whatsapp',
        params: filter
      });
      commit('setWhatsappStatisticGroup', resp.data);
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async exportWhatsappStatisticGroup({commit}, filter: GroupFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/group/whatsapp/export',
        params: filter
      });
      return resp;
    } catch (err) {
      throw err;
    }
  },
};